'use client';

import React, { useEffect } from 'react';
import { ServerCrash, RotateCcw, Home } from 'lucide-react';
import Navbar from './components/Navbar';
import Link from 'next/link';

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div className="bg-white min-h-screen flex flex-col relative overflow-hidden">
      <Navbar onLoginClick={() => {}} hideNav />
      
      <main className="flex-1 flex items-center justify-center p-6 relative z-10 mt-10 md:mt-16">
        <div className="w-full max-w-xl text-center flex flex-col items-center">
          
          <div className="w-20 h-20 mb-10 flex items-center justify-center rounded-2xl bg-red-50">
            <ServerCrash className="w-8 h-8 text-red-500" />
          </div>
          
          <h1 className="text-6xl md:text-8xl font-bold text-slate-800 tracking-tight mb-2" style={{ fontFamily: "'Sharp Grotesk SmBold 13', 'Inter', sans-serif" }}>
            500
          </h1>
          <h2 className="text-2xl md:text-3xl font-bold text-slate-700 tracking-tight mb-4" style={{ fontFamily: "'Sharp Grotesk SmBold 13', 'Inter', sans-serif" }}>
            Internal Server Error
          </h2>
          
          <p className="text-slate-500 text-lg leading-relaxed mb-12 max-w-md">
            Something went wrong on our end. Please try again later.
          </p>

          <div className="flex items-center gap-4">
            <button 
              onClick={() => reset()}
              className="group flex items-center gap-3 bg-red-50 hover:bg-red-100 text-red-600 transition-all duration-300 px-6 py-3.5 rounded-xl border border-red-200"
            >
              <RotateCcw className="w-5 h-5" />
              <span className="text-sm font-semibold">Try Again</span>
            </button>
            <Link 
              href="/"
              className="group flex items-center gap-3 bg-blue-500 hover:bg-blue-600 text-white transition-all duration-300 px-6 py-3.5 rounded-xl shadow-md hover:shadow-lg"
            >
              <Home className="w-5 h-5" />
              <span className="text-sm font-semibold">Back to Home</span>
            </Link>
          </div>
          
        </div>
      </main>
    </div>
  );
}
